import { render, staticRenderFns } from "./BoardDetail.vue?vue&type=template&id=fed112b6&scoped=true"
import script from "./BoardDetail.vue?vue&type=script&lang=js"
export * from "./BoardDetail.vue?vue&type=script&lang=js"
import style0 from "./BoardDetail.vue?vue&type=style&index=0&id=fed112b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed112b6",
  null
  
)

export default component.exports